// src/pages/WritePost/index.jsx
import { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Select } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { fakeApi } from '../../api/fakeApi';

const { TextArea } = Input;
const { Option } = Select;

const WritePost = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // 获取文章ID（如果是编辑模式）
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // 是否编辑模式
  const [postData, setPostData] = useState(null); // 文章数据
  
  // 预设标签选项
  const tagOptions = [
    '前端', 'React', 'JavaScript', 'Vue', 'Node.js',
    'TypeScript', 'CSS', 'HTML', 'Web开发', '编程',
    '技术', '生活', '学习', '分享', '教程', '开源',
    '算法', '数据结构', '工程化', '性能优化', '移动端'
  ];

  // 检查登录状态
  useEffect(() => {
    const user = localStorage.getItem('user');
    if (!user) {
      message.warning('请先登录再写文章');
      navigate('/auth');
      return;
    }

    // 检查是否是编辑模式
    if (id) {
      setIsEditMode(true);
      fetchPostData(parseInt(id));
    }
  }, [id, navigate]);

  // 获取文章数据
  const fetchPostData = async (postId) => {
    try {
      const response = await fakeApi.posts.getPost(postId);
      if (response.success) {
        setPostData(response.data);
        // 填充表单数据
        form.setFieldsValue({
          title: response.data.title,
          content: response.data.content,
          tags: response.data.tags || [] // 修改：直接使用数组
        });
        
        // 检查编辑权限
        const user = JSON.parse(localStorage.getItem('user'));
        if (user.name !== response.data.author) {
          message.error('您只能编辑自己发布的文章');
          navigate('/postcard');
        }
      } else {
        message.error('文章不存在');
        navigate('/write');
      }
    } catch (error) {
      message.error('加载文章失败');
      navigate('/write');
    }
  };

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // 再次检查登录状态
      const user = JSON.parse(localStorage.getItem('user'));
      if (!user) {
        message.warning('请先登录');
        navigate('/auth');
        return;
      }
      
      // 处理标签 - 现在直接使用数组
      const tags = values.tags || [];
      
      if (isEditMode && id) {
        // 编辑模式：更新文章
        const response = await fakeApi.posts.updatePost(parseInt(id), {
          title: values.title,
          content: values.content,
          tags: tags
        });
        
        if (response.success) {
          message.success('文章更新成功！');
          form.resetFields();
          navigate(`/post/${id}`);
        } else {
          message.error(response.message || '更新失败');
        }
      } else {
        // 创建模式：发布新文章
        const response = await fakeApi.posts.createPost({
          title: values.title,
          content: values.content,
          author: user.name,
          authorAvatar: user.name.charAt(0),
          tags: tags
        });
        
        if (response.success) {
          message.success('文章发布成功！');
          form.resetFields();
          navigate('/postcard');
        } else {
          message.error(response.message || '发布失败');
        }
      }
    } catch (error) {
      message.error(isEditMode ? '更新失败，请重试' : '发布失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title={isEditMode ? "编辑文章" : "写文章"}>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            name="title"
            label="文章标题"
            rules={[{ required: true, message: '请输入文章标题' }]}
          >
            <Input placeholder="请输入文章标题" />
          </Form.Item>

          <Form.Item
            name="content"
            label="文章内容"
            rules={[{ required: true, message: '请输入文章内容' }]}
          >
            <TextArea 
              placeholder="开始写作吧..." 
              rows={10}
              showCount
              maxLength={5000}
            />
          </Form.Item>

          <Form.Item
            name="tags"
            label="标签"
          >
            <Select
              mode="multiple"
              placeholder="选择或输入标签"
              style={{ width: '100%' }}
              allowClear
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={tagOptions.map(tag => ({
                value: tag,
                label: tag
              }))}
              tokenSeparators={[',']}
            />
          </Form.Item>

          <Form.Item style={{ textAlign: 'right' }}>
            <Button 
              onClick={() => {
                if (isEditMode && id) {
                  navigate(`/post/${id}`);
                } else {
                  navigate('/postcard');
                }
              }} 
              style={{ marginRight: 8 }}
              disabled={loading}
            >
              取消
            </Button>
            <Button type="primary" htmlType="submit" loading={loading}>
              {isEditMode ? '更新文章' : '发布文章'}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default WritePost;